function Choose() {
  const reasons = [
    {
      number: "01",
      title: "Arquitetura de Software",
      description:
        "Projetamos soluções escalaveis, seguras e prontas para acompanhar o crescimento do seu negocio.",
    },
    {
      number: "02",
      title: "Suporte Tecnico Consultivo",
      description:
        "Atuamos lado a lado com sua equipe para evoluir produto, corrigir gargalos e orientar decisoes tecnicas.",
    },
    {
      number: "03",
      title: "Entrega com Foco em Valor",
      description:
        "Cada etapa do desenvolvimento prioriza impacto real, prazo claro e resultado percebido pelo cliente.",
    },
    {
      number: "04",
      title: "Squad Agil e Especializado",
      description:
        "Unimos design, produto e engenharia em um fluxo rapido para transformar ideias em software de qualidade.",
    },
    {
      number: "05",
      title: "Tecnologia Sob Medida",
      description:
        "Desenvolvemos plataformas web, apps e integracoes de acordo com o contexto operacional de cada projeto.",
    },
    {
      number: "06",
      title: "Experiencia do Usuario",
      description:
        "Criamos interfaces intuitivas e processos bem pensados para aumentar adocao, produtividade e satisfacao.",
    },
  ];

  return (
    <section className="section section-bgc" id="choose">
      <div className="container">
        <div className="row litems">
          <header className="col-12">
            <div className="section-heading heading-center">
              <div className="section-subheading">Por que a AM Systems</div>
              <h2>Nossos Diferenciais</h2>
            </div>
          </header>

          {reasons.map((reason) => (
            <div className="col-lg-4 col-md-6 col-12 litem" key={reason.number}>
              <div className="ini">
                <div className="ini-count">{reason.number}</div>
                <div className="ini-info">
                  <h3 className="ini-heading item-heading-large">{reason.title}</h3>
                  <div className="ini-desc">
                    <p>{reason.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Choose;
